<template>
    <span class="svgicon svgicon--shopping-cart">
        <svg :width="iconSize"
             viewBox="0 0 24 24"
             version="1.1"
             xmlns="http://www.w3.org/2000/svg"
             xmlns:xlink="http://www.w3.org/1999/xlink"
             xml:space="preserve">
        <path d="M0.5,3H4c0.232,0,0.434,0.16,0.487,0.386L5.809,9H23.5c0.161,0,0.313,0.077,0.406,0.208s0.119,0.299,0.068,0.451l-3,9  C20.906,18.862,20.716,19,20.5,19H8.161l0.235,1H19c1.104,0,2,0.898,2,2c0,1.104-0.896,2-2,2c-1.103,0-2-0.896-2-2  c0-0.365,0.106-0.704,0.278-1H9.723C9.895,21.296,10,21.635,10,22c0,1.104-0.896,2-2,2c-1.103,0-2-0.896-2-2  c0-0.89,0.588-1.637,1.394-1.896L3.604,4H0.5C0.225,4,0,3.776,0,3.5S0.225,3,0.5,3z"
              :style="`fill: ${color};`" />

        </svg>
        <span v-if="itemsCount > 0" :style="`background-color: ${colorOfBadge};`" class="layoutHeaderButton__badge">{{ itemsCount }}</span>
    </span>
</template>

<script>
    export default {
        name: "CartIcon",
        props: {
            direction: {
                type: String,
                default: "left"
            },
            color: {
                type: String,
                default: "#005bff"
            },
            colorOfBadge: {
              type: String,
              default: "#db0d47"
            },
            size: {
                type: [String, Number]
            },
            itemsCount: {
                type: Number
            }
        },
        data: () => ({
            sm: 6,
            md: 10,
            lg: 16
        }),
        computed: {
            iconSize() {
                if (typeof this.size === "string") {
                    switch (this.size) {
                        case "small":
                            return `${this.sm}px`;
                        case "medium":
                            return `${this.md}px`;
                        case "large":
                            return `${this.lg}px`;
                        default:
                            return this.size;
                    }
                }
                if (typeof this.size === "number") {
                    return `${this.size}px`;
                }
                return "28px";
            },
            iconDirection() {
                const up = "rotate(270deg)";
                const right = "rotate(0deg)";
                const left = "rotate(180deg)";
                const bottom = "rotate(90deg)";
                switch (this.direction) {
                    case "up":
                        return { transform: up };
                    case "right":
                        return { transform: right };
                    case "left":
                        return { transform: left };
                    case "bottom":
                        return { transform: bottom };
                    default:
                        return { transform: right };
                }
            }
        }
    };
</script>
<style scoped lang="scss">

    .svgicon--shopping-cart {
        /* -webkit-filter: drop-shadow(0 0 7px rgba(0,91,255,.5));
    filter: drop-shadow(0 0 7px rgba(0,91,255,.5)); */
    }

    .svgicon {
        display: inline-block;
        vertical-align: top;
    }

    @media (max-width: 991px) and (min-width: 768px) {
        .layoutHeaderButton__badge {
            top: .4rem;
        }
    }

    @media (min-width: 768px) {
        .layoutHeaderButton__badge {
            right: auto;
            left: 55%;
        }
    }

    .layoutHeaderButton__badge {
        position: absolute;
        left: 20px;
        top: 4px;
        display: block;
        border-radius: 8px;
        height: 1.1rem;
        overflow: hidden;
        width: 1.1rem;
        line-height: 1.1rem;
        text-align: center;
        background-color: #db0d47;
        color: #fff;
        font-weight: 900;
        font-size: .6rem;
        -webkit-box-shadow: 0 0 7px rgba(0, 91, 255, 0.5);
        box-shadow: 0 0 7px rgba(0, 91, 255, 0.5);
        background-image: -webkit-gradient(linear, left top, left bottom, from(transparent), to(rgba(0, 0, 0, 0.1)));
        background-image: linear-gradient(180deg, transparent, rgba(0, 0, 0, 0.1));
    }
</style>
